import GuestListActions from '../../actions/GuestListActions';
import AjaxPromises from '../../utils/AjaxPromises';
import DropdownProfile from '../profile/view/DropdownProfile.react';
import { endPoints as GuestListEndPoints } from '../../constants/GuestListConstants';
import UserStore from '../../stores/UserStore';

class CheckoutButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            visible : false,
            cancelReasons: [],
            selectedCancelReason: '',
            isCancelling: false,
        };

        this.checkOut = this.checkOut.bind(this);
    }

    componentDidUpdate() {
        if (this.state.visible && this.state.cancelReasons.length == 0) {
            this.getCancellationReasons();
        }
    }

    getCancellationReasons() {
        AjaxPromises.POST(GuestListEndPoints.GET_CANCELLATION_REASONS, UserStore.getApiData()).then(res => {
            let options = [{title: 'Cancellation Reason', option: ''}];
            res.Data.forEach(x => options.push({title: x.Reason, option: x.Reason}));
            this.setState({ cancelReasons: options});
        });
    }

    checkOut() {
        this.setState({ isCancelling: true }, () => {
            const { guest } = this.props;
            GuestListActions.checkGuestOut(guest, this.state.selectedCancelReason);
            if(UserStore.getState().selectedLocation.UseSmartCheckin){
                this.setState({visible:false, isCancelling: false});
            }
        });
    }

    render() {
        var style = this.state.cancelReasons.length > 1 ? {'width' : '260px', 'height' : 'auto'} : {'width' : '260px', 'height' : '100px'};

        return (
            <li>
                <div
                    className={'btn-green'}
                    onClick={() => { this.setState({ visible: true }) }}>

                    CANCEL
                </div>

                { this.state.visible &&
                    <div className='popup popup__transparent'>
                        <div className='popup__content release' style={style} >

                            <div className='popup-header'>
                                CONFIRM

                                <div
                                    className='popup-close'
                                    onClick={() => { this.setState({ visible : false }) }}>

                                    <i className="fa fa-times" aria-hidden="true" />
                                </div>
                            </div>

                            <button
                                className={`btn-green ${this.state.isCancelling ? 'btn-green__disabled' : ''}`}
                                disabled={this.state.isCancelling}
                                onClick={() => { this.setState({ visible : false }); }}
                            >
                                CANCEL
                            </button>

                            <button
                                className={`btn-green ${this.state.isCancelling ? 'btn-green__disabled' : ''}`}
                                disabled={this.state.isCancelling}
                                onClick={this.checkOut}
                            >
                                {this.state.isCancelling ? <i className="fa fa-spinner fa-pulse" /> : 'CONFIRM'}
                            </button>

                        {this.state.cancelReasons.length > 1 &&
                        <div style={{margin: '15px 5px'}}>
                            <DropdownProfile
                                options={this.state.cancelReasons}
                                selected={this.state.selectedCancelReason}
                                onChange={(field, selectedCancelReason) => { this.setState({ selectedCancelReason });}} />  
                        </div>    
                        }
                        </div>
                    </div>
                }
            </li>
        );
    }
}

export default CheckoutButton;



// WEBPACK FOOTER //
// ./ui_src/app/components/button/CheckoutButton.react.jsx